export function filterSummaryAppliedFiltersHandler(appliedFilters: any) {
  const { availabilities } = appliedFilters;
  const filterSummaryAppliedFilters = { ...appliedFilters };
  if (availabilities && availabilities.length > 0) {
    const updatedAvalablilities = [...availabilities];
    const index = updatedAvalablilities.indexOf("In Stock");
    if (index > -1) {
      updatedAvalablilities.splice(index, 1);
    }
    if (updatedAvalablilities.length > 0) {
      filterSummaryAppliedFilters.availabilities = updatedAvalablilities;
      return filterSummaryAppliedFilters;
    }
    filterSummaryAppliedFilters.availabilities = null;
    return filterSummaryAppliedFilters;
  }
  return filterSummaryAppliedFilters;
}
